module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6n8r7r-e83b0dab7bc6fa3c7c79538e56a780bb.svg";